import axios from '../axios-auth';
import orginal_axios from "axios";

export const productionReportService = {
    getProductionReportList,
    exportAllProductionReportList,
};

function getProductionReportList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }
    if (searchParams.orderMonth) {
        params["orderMonth"] = searchParams.orderMonth;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }

    return axios.get("/auth/production-reports", { params });
}

function exportAllProductionReportList(searchParams) {
    let params = {};

    if (searchParams.financeSettingId) {
        params["financeSettingId"] = searchParams.financeSettingId;
    }
    if (searchParams.orderMonth) {
        params["orderMonth"] = searchParams.orderMonth;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/production-report-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}